import { type z } from "zod";

const NOT_DEFINED = "__NOT_DEFINED__" as const;

export const formatZodIssue = ({
  message,
  code,
  path,
  expected = NOT_DEFINED,
  received = NOT_DEFINED,
}: {
  readonly code: z.ZodIssueCode;
  readonly message: string;
  readonly path: (string | number)[];
  readonly expected?: unknown;
  readonly received?: unknown;
}) => {
  return (
    [
      `code = ${code}`,
      `path = ${path}`,
      expected !== NOT_DEFINED
        ? `expected = ${JSON.stringify(expected)}`
        : undefined,
      received !== NOT_DEFINED
        ? `received = ${JSON.stringify(received)}`
        : undefined,
    ]
      .filter((v) => v !== undefined)
      .join(" | ") + `: ${message}`
  );
};

export const formatZodError = (e: z.ZodError) =>
  e.issues.map((issue, i) => `${i + 1}. ${formatZodIssue(issue)}`).join("\n");
